import React, { Fragment } from 'react';
//import spinner from './spinner.gif';
import ripple from './ripple.gif';

export default () => (
  <Fragment>
    <img
      src={ripple}
      style={{ width: '50px', margin: 'auto', display: 'block' }}
      alt='Loading...'
    />
    <div className="small text-center" style={{color: "blue", fontWeight: "bold"}}> Loading </div>
  </Fragment>
);
